export { EditStudentsModal } from './EditStudentsModal'
export type { EditStudentsModalProps } from './types'
